import React from "react";
import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";

const Header = () => {
  const navigate = useNavigate();

  return (
    <header className="bg-slate-950 border-b border-slate-800">
      <div className="pl-4">
        <div className="h-16 flex items-center">
          <div 
            className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => navigate("/")}
          >
            <FileText className="w-6 h-6 text-cyan-500" />
            <h1 className="text-xl font-bold text-white">
              Medical Report Extractor
            </h1>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;